import React, {useEffect} from "react";
import fetchAccountingAction  from "@pillvery/redux/accounting/actions";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useLocation} from "react-router-dom";
import {uniqueKeys} from "../../config/pillveryVariables";
import AccountingList from "../Accounting/AccountingList";
import Pagination from "react-js-pagination";

const { fetchAccounting }  = fetchAccountingAction;

export default function LatestTransactions() {
    const dispatch = useDispatch();
    const { accounting , loading } = useSelector(state => state.Accounting);
    const history = useHistory();
    const location = useLocation();
    const currentUrlParams = new URLSearchParams(location.search);

    let params = {
        page: parseInt(currentUrlParams.get("transaction_page")) || 1,
        limit: 10,
        sort_type: 'desc',
        sort_field: 'created_at'
    }

    useEffect(()=>{
        dispatch(fetchAccounting(params));
    },[])

    const pagination = {
        total       : accounting?.total_count,
        pageSize    : params.limit,
        activePage  : params.page
    };

    let showingData = pagination.pageSize * pagination.activePage;

    if(showingData > pagination.total){
        showingData = pagination.total
    }

    function handlePageChange(pageNumber) {
        currentUrlParams.set("transaction_page", pageNumber);
        history.push(location.pathname + "?" + currentUrlParams.toString());
        params.page = pageNumber;
        dispatch(fetchAccounting(params));
    }

    return (
        <div className="col-md-12 grid-margin  stretch-card">
            <div className="card">
                <div className="card-body">
                    <div className="d-flex align-items-start justify-content-between">
                        <p className="card-title flex-grow">Latest Transactions</p>
                        {/*<div className="dropdown dropright card-menu-dropdown">*/}
                        {/*    <button className="btn" type="button" id="cardMenuButton8"*/}
                        {/*            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">*/}
                        {/*        <i className="mdi mdi-dots-horizontal card-menu-btn"></i>*/}
                        {/*    </button>*/}
                        {/*    <div className="dropdown-menu" aria-labelledby="cardMenuButton8">*/}
                        {/*        <a className="dropdown-item" href="#">Action</a>*/}
                        {/*        <a className="dropdown-item" href="#">Another action</a>*/}
                        {/*        <a className="dropdown-item" href="#">Something else here</a>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>
                    <AccountingList
                        accounting = { accounting?.data || []}
                        loading = { loading }
                    />

                    {/*<div className="d-flex justify-content-between align-items-center flex-wrap">*/}
                    {/*    <nav>*/}
                    {/*        <ul className="pagination flex-wrap pagination-separated pagination-dark mt-3 mb-0">*/}
                    {/*            <li className="page-item"><a className="page-link" href="#">Prev</a>*/}
                    {/*            </li>*/}
                    {/*            <li className="page-item"><a className="page-link" href="#">1</a></li>*/}
                    {/*            <li className="page-item"><a className="page-link" href="#">2</a></li>*/}
                    {/*            <li className="page-item"><a className="page-link" href="#">Next</a>*/}
                    {/*            </li>*/}
                    {/*        </ul>*/}
                    {/*    </nav>*/}
                    {/*    <p className="text-muted mt-3 mb-0 ml-3 ml-md-0 d-none d-md-block">*/}
                    {/*        Showing 6 out of 100*/}
                    {/*    </p>*/}
                    {/*</div>*/}
                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                        <nav>
                            <Pagination
                                innerClass          = "pagination flex-wrap pagination-separated pagination-dark mt-3 mb-0"
                                activePage          = { pagination.activePage }
                                itemsCountPerPage   = { pagination.pageSize }
                                totalItemsCount     = { pagination.total }
                                pageRangeDisplayed  = { 5 }
                                itemClass           = "page-item"
                                linkClass           = "page-link"
                                onChange            = { handlePageChange.bind() }
                                firstPageText       = "first"
                                lastPageText        = "last"
                                nextPageText        = "next"
                                prevPageText        = "prev"
                                activeClass         = "btn-primary"
                                hideDisabled        = { false }
                            />

                        </nav>
                        <p className="text-muted mt-3 mb-0 ml-3 ml-md-0 d-none d-md-block">
                            Showing { showingData } out of { pagination.total }
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}